import type {UseMessagesReturn} from '@/components/ChatSection/hooks/useMessages'
import {useLocale} from '@/lib/locale/locale'
import {type RawMinimalProduct} from '@/models/productModel'
import queries from '@/queries/queries'
import {getProduct} from '@/services/productService'

import ProductCard from './ProductCard'
import ProductCardPlaceholder from './ProductCardPlaceholder'

interface Props {
  rawMinimalProduct: RawMinimalProduct
  submitMessage: UseMessagesReturn['submitMessage']
}

function SuspensedProduct({rawMinimalProduct, submitMessage}: Props) {
  const [locale] = useLocale()

  const {data: product} = useSuspenseQuery(
    queries.getQueryOptions(
      {
        name: 'product',
        params: [rawMinimalProduct.retailer, rawMinimalProduct.id, locale],
        queryFn: async ({signal, queryKey}) =>
          getProduct({
            signal,
            locale,
            retailer: queryKey[1],
            id: queryKey[2],
          }),
      },
      true,
    ),
  )

  return product ? (
    <ProductCard product={product} isInMessage submitMessage={submitMessage} headingLevel={2} />
  ) : null
}

export default memo(function MinimalProductCard(props: Props) {
  return (
    // <ProductCardPlaceholder />
    <Suspense fallback={<ProductCardPlaceholder />}>
      <SuspensedProduct {...props} />
    </Suspense>
  )
})
